import type { TranslationKey } from '$core/i18n';

export type SessionAction =
  | 'problem.toggle'
  | 'problem.next'
  | 'problem.discard'
  | 'problem.rate1'
  | 'problem.rate2'
  | 'problem.rate3'
  | 'macro.start'
  | 'macro.pause'
  | 'macro.resume'
  | 'macro.finish';

export interface ShortcutSpec {
  action: SessionAction;
  labelKey: TranslationKey;
}

export const SHORTCUTS: readonly ShortcutSpec[] = [
  { action: 'problem.toggle', labelKey: 'shortcuts.problemToggle' },
  { action: 'problem.next', labelKey: 'shortcuts.problemNext' },
  { action: 'problem.discard', labelKey: 'shortcuts.problemDiscard' },
  { action: 'problem.rate1', labelKey: 'shortcuts.rate1' },
  { action: 'problem.rate2', labelKey: 'shortcuts.rate2' },
  { action: 'problem.rate3', labelKey: 'shortcuts.rate3' },
  { action: 'macro.start', labelKey: 'shortcuts.macroStart' },
  { action: 'macro.pause', labelKey: 'shortcuts.macroPause' },
  { action: 'macro.resume', labelKey: 'shortcuts.macroResume' },
  { action: 'macro.finish', labelKey: 'shortcuts.macroFinish' }
] as const;

export type ShortcutMap = Record<SessionAction, string>;

export const DEFAULT_SHORTCUTS: ShortcutMap = {
  'problem.toggle': ' ',
  'problem.next': 'n',
  'problem.discard': 'Escape',
  'problem.rate1': '1',
  'problem.rate2': '2',
  'problem.rate3': '3',
  'macro.start': 's',
  'macro.pause': 'p',
  'macro.resume': 'r',
  'macro.finish': 'f'
};

export function findActionFor(
  shortcuts: ShortcutMap,
  key: string
): SessionAction | null {
  const lower = key.length === 1 ? key.toLowerCase() : key;
  for (const action of Object.keys(shortcuts) as SessionAction[]) {
    const mapped = shortcuts[action];
    if (!mapped) continue;
    const mappedNorm = mapped.length === 1 ? mapped.toLowerCase() : mapped;
    if (mappedNorm === lower) return action;
  }
  return null;
}

export function formatKeyLabel(key: string): string {
  if (!key) return '';
  if (key === ' ') return 'Space';
  if (key === 'Escape') return 'Esc';
  if (key === 'ArrowUp') return '↑';
  if (key === 'ArrowDown') return '↓';
  if (key === 'ArrowLeft') return '←';
  if (key === 'ArrowRight') return '→';
  if (key === 'Enter') return 'Enter';
  if (key === 'Tab') return 'Tab';
  if (key.length === 1) return key.toUpperCase();
  return key;
}